import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { theme } from "../../components/constants/muiTheme";
import SfaDetail from "../../components/screen/Sfa/SfaDetail";

const SfaDetailPage = () => {
  return (
    <div>
      <PageTemplate
        mainComponent={
          <ThemeProvider theme={theme}>
            <SfaDetail />
          </ThemeProvider>
        }
        pageRole={3}
        header="OLISA Detail"
      />
    </div>
  );
};

export default HOC(SfaDetailPage);
